import { styled } from '@volkswagen-onehub/components-core';

export const AccordionGroupContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
